export default {
    list: { method: 'get', url: 'v1/movida/sessions' },
}
